import FilterComponent from './Component'
import Router from '@/router'
import { path } from 'ramda'
import { hasDiff } from '@/utils'

const FilterMixin = (options = {}) => {
  const computed = {}

  let defaultFilter = options.default || path(['meta', 'defaultFilter'], Router.currentRoute)

  let defaultFilterGetter = function () {
    let defaultFilter = this.$path('meta.defaultFilter', this.$route) || options.default
    switch (typeof defaultFilter) {
      case 'function':
        return defaultFilter.call(this, this)
      case 'string':
        return this.$path(defaultFilter, this)
      default:
        return defaultFilter
    }
  }

  if (defaultFilter && typeof defaultFilter !== 'string') computed.defaultFilter = defaultFilterGetter

  return {
    data() {
      return {
        filter: defaultFilterGetter.call(this),
      }
    },
    computed: {
      hasFilters() {
        return hasDiff(this.$path(typeof defaultFilter === 'string' ? defaultFilter : 'defaultFilter'), this.filter)
      },
      ...computed,
    },
    components: {
      FilterComponent,
    },
  }
}

export default FilterMixin
